import React from 'react';
import { useTranslation } from 'react-i18next';
import { INewCartEntry } from 'pages/NewCart/ICart';
import { ReactComponent as FreebieGiftSvg } from 'assets/svgs/freebieGift.svg';
import ProductImage from '../ProductImage';
import * as S from './CartListItem.style';

const FreebieCardListItem: React.FC<{
  entry: INewCartEntry;
}> = ({ entry = {} as INewCartEntry }) => {
  const { t } = useTranslation();
  const { product } = entry;
  const { name } = product;

  return (
    <S.FreebieCartListItem isExpressProduct={product.isExpressProduct}>
      <S.Product>
        <S.FreebieLabelWraper>{t('freebieCartItem.freebie')}</S.FreebieLabelWraper>
        <ProductImage product={product} mr={'2'} outOfStock={false} isNowShipment={false} />
        <S.ProductDetails>
          <S.FreebieProductTitle>{name}</S.FreebieProductTitle>
          <S.GiftItemWrapper>
            <FreebieGiftSvg />
          </S.GiftItemWrapper>
          <S.FreebieText>{t('freebieCartItem.congratulations')}</S.FreebieText>
          <S.FreebieText>{t('freebieCartItem.freebieTextMessage')}</S.FreebieText>
        </S.ProductDetails>
      </S.Product>
    </S.FreebieCartListItem>
  );
};

export default FreebieCardListItem;
